import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {MarkdownViewer, translate} from 'views/module';

import {getMessageTitle} from '../../communicationUtils';

import displayResource from 'utils/miscellaneous/display_resource';
import moment from 'moment';

const InternalMessage = (props) => {
  const {
    message,
  } = props;

  const createdAtMoment = moment(message.createdAt);
  const submittedBy = displayResource(message.submittedBy);
  const messageBody = message?.body?.blob || '';

  return (
    <Box
      sx={{
        border: '1px solid #ECECF1',
        borderRadius: '9px',
        backgroundColor: '#FFFFFF',
        p: '14px 15px',
      }}
    >
      <Stack sx={{gap: 0.85}}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 700,
              color: '#050A14',
            }}
          >
            {getMessageTitle(message.messageType)}
          </Typography>
          <Typography
            sx={{
              flexShrink: 0,
              fontSize: '11px',
              fontWeight: 400,
              color: '#9A9BAE',
            }}
          >
            {createdAtMoment.isValid() ? createdAtMoment.format('MMM D, h:mm A') : ''}
          </Typography>
        </Box>
        {
          submittedBy && (
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#9A9BAE',
                wordBreak: 'break-word',
              }}
            >
              {submittedBy}
            </Typography>
          )
        }
        <Box
          sx={{
            mt: 0.75,
            pt: 1.25,
            borderTop: '1px solid #ECECF1',
            fontSize: '12px',
            lineHeight: '18px',
            color: '#050A14',
            wordBreak: 'break-word',
          }}
        >
          <MarkdownViewer value={messageBody || translate('case.Communication.EmptyMessageBody')} truncate />
        </Box>
      </Stack>
    </Box>
  );
};

InternalMessage.propTypes = {
  message: PropTypes.object.isRequired,
};

export default React.memo(InternalMessage);
